import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 控制订单详情对话框是否显示
    isShowBillsModel: false,
    // 控制呼叫历史对话框是否显示
    isShowCallHistoryModel: false,
    // 控制外呼设置对话框是否显示
    isShowCallSettingModel: false,
    // 报表页面是否显示管理员报表权限
    isShowReportWithAdmin: true,
    // 查录音弹窗
    isShowRecordHistoryModel: false,
    smsBody: {
      smsCode: '',
      smsText: '',
      smsHtml: '',
      smsParams: []
    }
  },
  mutations: {
    addSmsParam (state, param) {
      state.smsBody.smsParams.push(param)
    }
  },
  actions: {

  }
})
